import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArchive1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArchive1"><Path d="M20.5 7.5V20.5H3.5V7.5" stroke="currentColor" strokeLinecap="square"/><Path d="M2.5 3.5H21.5V7.5H2.5V3.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M10 11.5H14" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArchive1;
